import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ScanLine, Home, AlertCircle, CheckSquare } from 'lucide-react';
const deliverables = [{
  icon: <BookOpen className="w-6 h-6" data-id="element-164" />,
  title: 'El Protocolo Paso a Paso',
  description: 'La secuencia exacta de 7 minutos (desde la presión táctil hasta la transferencia a la cuna).'
}, {
  icon: <ScanLine className="w-6 h-6" data-id="element-165" />,
  title: 'El Escáner de 2 Minutos',
  description: 'Cómo detectar exactamente por qué no se duerme antes de que empiece el llanto.'
}, {
  icon: <Home className="w-6 h-6" data-id="element-166" />,
  title: 'Manual del Ambiente "Útero"',
  description: 'Los 3 ajustes clave en tu habitación para que el bebé no se despierte a los 20 minutos.'
}, {
  icon: <AlertCircle className="w-6 h-6" data-id="element-167" />,
  title: 'El Guion de Emergencia de las 2 AM',
  description: 'Qué decir y qué hacer palabra por palabra cuando hay una crisis nocturna.'
}, {
  icon: <CheckSquare className="w-6 h-6" data-id="element-168" />,
  title: 'Lista de Verificación',
  description: 'Auditoría de seguridad y confort para el sueño profundo.'
}];
export function WhatYouGet() {
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown mb-4" data-id="element-172">
            Esto es lo que recibes
          </h2>
          <p className="text-lg text-brand-textLight max-w-2xl mx-auto" data-id="element-173">
            Todo lo que necesitas para implementar el Anclaje Sensorial esta
            misma noche, sin relleno ni teoría innecesaria.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-174">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-3xl shadow-sm border border-brand-brown/5 hover:shadow-md transition-shadow ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-brand-blue/5 border-brand-blue/20' : ''}`} data-id="element-175">
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${index === 0 ? 'bg-brand-blue text-white' : 'bg-brand-cream text-brand-brown'}`} data-id="element-176">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-text mb-3" data-id="element-177">
                {item.title}
              </h3>
              <p className="text-brand-textLight leading-relaxed" data-id="element-178">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}